import DashbordSidebar from 'organization/theme/Sidebar'
import React from 'react'
import {LocalLink} from 'i18n/LocalLink'
import small_logo from 'assets/img/logo/logo-small.svg'
import {useOrganizationEventRoutes} from 'organization/OrganizationRoutes'
import SettingsIcon from '@mui/icons-material/Settings'
import ExtensionIcon from '@mui/icons-material/Extension'
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber'
import DesignServicesIcon from '@mui/icons-material/DesignServices'
import QueryStatsIcon from '@mui/icons-material/QueryStats'
import PointOfSaleIcon from '@mui/icons-material/PointOfSale'
import PersonIcon from '@mui/icons-material/Person'
import {routes as defaultRoutes} from 'routes/routes'
import PlayCircleIcon from '@mui/icons-material/PlayCircle'
import LiveHelpIcon from '@mui/icons-material/LiveHelp'
import PublicIcon from '@mui/icons-material/Public'
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium'
import CategoryIcon from '@mui/icons-material/Category'
import CloudSyncIcon from '@mui/icons-material/CloudSync'
import {SidebarFooterLinks} from 'organization/theme/Sidebar/Menu'
import {useI18n} from 'i18n/I18nContext'

export const EventSidebar = () => {
  const {t} = useI18n()
  const routes = useOrganizationEventRoutes()

  const Menu = (
    <>
      <div className="logo-details">
        <span>
          <LocalLink to={defaultRoutes.organization.list}>
            <img
              style={{width: '100%', height: '100%', maxHeight: '50px'}}
              className="logo__white"
              src={small_logo}
              alt={t('logo.notFound')}
            />
          </LocalLink>
        </span>
        <span>
          <LocalLink to={defaultRoutes.organization.list}>
            <img
              style={{width: '180px', height: 'auto'}}
              className="log__smnall"
              src={process.env.PUBLIC_URL + '/logo-dark.svg'}
              alt={t('logo.notFound')}
            />
          </LocalLink>
        </span>
      </div>
      <div className="sidebar__inner simple-bar">
        <div className="dlabnav">
          <ul className="metismenu" id="menu">
            <li>
              <LocalLink to={routes.root}>
                <i>
                  <QueryStatsIcon />
                </i>
                <span className="nav-text">{t('org.sidebar.stats')}</span>
              </LocalLink>
            </li>
            <li>
              <LocalLink to={routes.management}>
                <i>
                  <PlayCircleIcon />
                </i>
                <span className="nav-text">{t('org.sidebar.management')}</span>
              </LocalLink>
            </li>
            <li>
              <LocalLink to={routes.attendants}>
                <i>
                  <PersonIcon />
                </i>
                <span className="nav-text">{t('org.sidebar.attendees')}</span>
              </LocalLink>
            </li>

            <li>
              <LocalLink to={routes.page}>
                <i>
                  <DesignServicesIcon />
                </i>
                <span className="nav-text">{t('org.sidebar.privatePage')}</span>
              </LocalLink>
            </li>
            <li>
              <LocalLink to={routes.publicPage}>
                <i>
                  <PublicIcon />
                </i>
                <span className="nav-text">{t('org.sidebar.publicPage')}</span>
              </LocalLink>
            </li>
            <li>
              <LocalLink to={routes.tickets}>
                <i>
                  <ConfirmationNumberIcon />
                </i>
                <span className="nav-text">{t('org.sidebar.tickets')}</span>
              </LocalLink>
            </li>
            <li>
              <LocalLink to={routes.earning}>
                <i>
                  <PointOfSaleIcon />
                </i>
                <span className="nav-text">{t('org.sidebar.earnings')}</span>
              </LocalLink>
            </li>
            <li>
              <LocalLink to={routes.products}>
                <i>
                  <CategoryIcon />
                </i>
                <span className="nav-text">{t('org.sidebar.products')}</span>
              </LocalLink>
            </li>
            <li>
              <LocalLink to={routes.cetrifications}>
                <i>
                  <WorkspacePremiumIcon />
                </i>
                <span className="nav-text">
                  {t('org.sidebar.certificates')}
                </span>
              </LocalLink>
            </li>
            <li>
              <LocalLink to={routes.integrations.root}>
                <i>
                  <CloudSyncIcon />
                </i>
                <span className="nav-text">
                  {t('org.sidebar.integrations')}
                </span>
              </LocalLink>
            </li>
            <li>
              <LocalLink to={routes.addons}>
                <i>
                  <ExtensionIcon />
                </i>
                <span className="nav-text">{t('org.sidebar.addons')}</span>
              </LocalLink>
            </li>
            <li>
              <LocalLink to={routes.settings}>
                <i>
                  <SettingsIcon />
                </i>
                <span className="nav-text">{t('org.sidebar.settings')}</span>
              </LocalLink>
            </li>

            <li>
              <LocalLink to={routes.help}>
                <i>
                  <LiveHelpIcon />
                </i>
                <span className="nav-text">{t('org.sidebar.help')}</span>
              </LocalLink>
            </li>
          </ul>

          <div className="sidebar__copyright">
            <p>{t('common.allRightsReserved')} @ Atomica Group 2026</p>
            <SidebarFooterLinks>
              <li>
                <LocalLink to={defaultRoutes.terms}>
                  {t('footer.terms')}
                </LocalLink>
              </li>
              <li>
                <LocalLink to={defaultRoutes.privacy}>
                  {t('footer.privacy')}
                </LocalLink>
              </li>
              <li>
                <LocalLink to={defaultRoutes.cookies}>
                  {t('footer.cookies')}
                </LocalLink>
              </li>
            </SidebarFooterLinks>
          </div>
        </div>
      </div>
    </>
  )

  return <DashbordSidebar menu={Menu} />
}
